import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { ReCaptchaModule } from "angular2-recaptcha";

import { FrontendRoutingModule } from "./frontend.routing";
import { FrontendComponent } from "./frontend.component";
import { Page404Component } from "./page404.component";
import { FrontHeaderComponent } from "./generic/frontend-header/frontend-header.component";
import { FrontFooterComponent } from "./generic/frontend-footer/frontend-footer.component";
import { FrontLoginModalComponent } from "./login/login-f-modal.component";
import { FrontResetPasswordModalComponent } from "./login/reset-f-modal.component";
import { FrontSuccessModalComponent } from "./login/success-f-modal.component";
import { TokenFrontGuard } from "../../shared/token-front.guard";

@NgModule({
  imports: [
    CommonModule,
    NgbModule.forRoot(),
    FormsModule,
    ReactiveFormsModule,
    FrontendRoutingModule,
    ReCaptchaModule,
  ],
  exports: [],
  declarations: [
    FrontendComponent,
    FrontHeaderComponent,
    FrontFooterComponent,
    FrontLoginModalComponent,
    FrontResetPasswordModalComponent,
    FrontSuccessModalComponent,
    Page404Component,
  ],
  providers: [TokenFrontGuard],
  entryComponents: [
    FrontLoginModalComponent,
    FrontResetPasswordModalComponent,
    FrontSuccessModalComponent,
  ],
})
export class FrontendModule {}



// WEBPACK FOOTER //
// ./src/app/modules/frontend/frontend.module.ts